import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionType } from '../../../../Features/storefrontSlice';

function WebStoreCTABox() {
    const dispatch = useDispatch();

    const containerRef = useRef(null);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [containerHeight, setContainerHeight] = useState(0);
    const [divGap, setDivGap] = useState(0);
    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);

    useEffect(() => {
        const updateHeight = () => {
            if (containerRef.current) {
                setContainerHeight((160 / 800) * containerRef.current.clientWidth);
            }
        };

        const resizeObserver = new ResizeObserver(() => {
            updateHeight();
        });

        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }

        updateHeight();

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        setDivGap((zoomSize/100)*12);
        setTextSize((zoomSize/100)*14);
        setLineHeight((zoomSize/100)*26);
    }, [zoomSize]);

    function handleAddSectionClick() {
        dispatch(setSectionType('SECTION'));
    }

    return (
        <div ref={containerRef} style={{ height: `${containerHeight}px` }} className='w-full bg-[#F3F3F3] border border-primaryColor flex items-center justify-center'>
            <div style={{ gap: `${divGap}px`, fontSize: `${textSize}px`, lineHeight: `${lineHeight}px` }} className="flex flex-col items-center">
                <p className='font-normal text-[#000000]'>Start Designing your brand voice!</p>

                <button onClick={handleAddSectionClick} className='font-semibold text-primaryColor outline-none'>Add section</button>
            </div>
        </div>
    );
}

export default WebStoreCTABox;
